export default class WalkthroughPopup {
    /**
     * @param {string} name
     * @param {boolean} userHasSeen
     */
    constructor(name, userHasSeen,) {
        this._name = name;
        this._userHasSeen = userHasSeen;
    }

    get name() {
        return this._name;
    }

    /**
     *
     * @param {string} name
     */
    set name(name) {
        this._name = name;
    }

    get userHasSeen() {
        return this._userHasSeen;
    }

    /**
     *
     * @param {boolean} value
     */
    set userHasSeen(value) {
        this._userHasSeen = value;
    }

    toObject() {
        const obj = {};
        obj.name = this.name;
        obj.userHasSeen = this.userHasSeen;

        return obj;
    }
}